import React from 'react';
import {usePages} from "@ignitesales/neuro-application";

const StarterProgressBar = () => {
  const componentClass = 'progressBar';
  const { progress } = usePages();
  const progressValue = Math.round(progress.total);

  return <div className={componentClass} role="progressbar" aria-valuenow={progress.total || 1} aria-valuemin="0" aria-valuemax="100">
      {progressValue}%
  </div>;
};

export default StarterProgressBar;
